document.addEventListener("DOMContentLoaded", () => {
  const thumbnails = document.querySelectorAll(".product-images__thumbnail");
  const slides = document.querySelectorAll(".product-images__selected-image");

  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener("click", function (event) {
      event.preventDefault();

      const mediaId = this.getAttribute("data-id");

      thumbnails.forEach((t) =>
        t.classList.toggle("is-active", t.getAttribute("data-id") === mediaId)
      );

      slides.forEach((slide) => {
        slide.style.display = "none";
        slide.querySelectorAll("video").forEach((video) => video.pause());
      });

      const selected = document.getElementById(`product-image-${mediaId}`);
      if (!selected) return;
      selected.style.display = ""; // revert to the stylesheet display (flex for video on desktop)

      // Videos are deferred: inject the <video> from its template on first view only.
      const template = selected.querySelector("template");
      if (template && !selected.querySelector("video")) {
        selected.appendChild(template.content.cloneNode(true));
      }

      const video = selected.querySelector("video");
      if (video) {
        // The click is a user gesture, so playing with sound is allowed.
        video.muted = false;
        video.play().catch(() => {
          // Fall back to muted playback if the browser still blocks audio.
          video.muted = true;
          video.play().catch(() => {});
        });
      }
    });
  });
});
